export const PACKAGE_NAME = '@jira/admin-pages__system-announcement-banner-resources' as const;

export const PRIVACY_LEVEL_PRIVATE = 'private' as const;
export const PRIVACY_LEVEL_PUBLIC = 'public' as const;
